import React, {Component} from 'react'
import {Query} from 'react-apollo'
import PropTypes from 'prop-types'
import LogService from './services/log-service'
import {RATES_QUERY} from './graphql/queries/rates'
// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
import withCacheClient from '@cred/shared/hoc/withCacheClient'

class RateGQL extends Component {
  static propTypes = {
    rateType: PropTypes.string.isRequired,
    vertical: PropTypes.string,
    lenderSlug: PropTypes.string,
    term: PropTypes.number,
    variable: PropTypes.bool,
    name: PropTypes.string,
    decimals: PropTypes.number,
    append: PropTypes.string,
    prepend: PropTypes.string
  }

  static defaultProps = {
    decimals: 2,
    append: '%',
    prepend: ''
  }

  queryHandler = ({loading, error, data}) => {
    const {className, decimals, append, prepend} = this.props

    if (error) {
      LogService.error(`[Rates] Error getting a rate: ${error}`)

      return null
    }

    if (loading) {
      return null
    }

    return <span className={className}>{this.getRateValue(data, {decimals, append, prepend})}</span>
  }

  getRateValue(data, options) {
    const rawValue = parseFloat(this.getRateRawValue(data)),
      optionsParsed = Object.assign({decimals: 2, append: '%', prepend: ''}, options)

    if (rawValue && !isNaN(rawValue)) {
      const convertedRawValue = rawValue.toFixed(optionsParsed.decimals)

      return optionsParsed.prepend + convertedRawValue + optionsParsed.append
    }
  }

  getRateRawValue(data) {
    if (data && data.searchRates[0]) {
      return data.searchRates[0].value
    }
  }

  render() {
    const {rateType, vertical, lenderSlug, term, variable, name} = this.props,
      args = {rateType, vertical, lenderSlug, term, variable, name}

    return (
      <Query query={RATES_QUERY} variables={{args, published: true}}>
        {this.queryHandler}
      </Query>
    )
  }
}

export {RateGQL}

export default /*#__PURE__*/ withCacheClient(RateGQL)
